import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
// pipes
import { SvgPipe } from './pipes/svg.pipe'
import { CapitalizeFirstCharPipe } from './pipes/capitalize-first-char.pipe'
import { ConfigFilterPipe } from './pipes/config-filter.pipe'
import { ConvertBooleanPipe } from './pipes/convert-boolean.pipe'
import { DateCustomPipe } from './pipes/date-custom.pipe'
import { ImageUrlPipe } from './pipes/image-url.pipe'
import { SingleSvgPipe } from './pipes/single-svg.pipe'
import { SortByPipe } from './pipes/sort-by.pipe'
import { TimeAgoPipe } from './pipes/time-ago.pipe'
import { ParseIsoPipe } from './pipes/parse-iso.pipe'
import { PhoneNumberPipe } from './pipes/phone-number'
import { FeedContentPipe } from './pipes/feed-content.pipe'
import { PersonNamePipe } from './pipes/person-name.pipe'
import { ScoreStatusPipe } from './pipes/score-status.pipe'
import { FatherNamePipe } from './pipes/father-name.pipe'
import { MotherNamePipe } from './pipes/mother-name.pipe'
import { AmountPipe } from './pipes/amount.pipe'

@NgModule({
    declarations: [
        SvgPipe,
        CapitalizeFirstCharPipe,
        ConfigFilterPipe,
        ConvertBooleanPipe,
        DateCustomPipe,
        ImageUrlPipe,
        SingleSvgPipe,
        SortByPipe,
        TimeAgoPipe,
        ParseIsoPipe,
        PhoneNumberPipe,
        FeedContentPipe,
        PersonNamePipe,
        FatherNamePipe,
        MotherNamePipe,
        ScoreStatusPipe,
        AmountPipe,
        AmountPipe,
    ],
    imports: [CommonModule],
    exports: [
        SvgPipe,
        CapitalizeFirstCharPipe,
        ConfigFilterPipe,
        ConvertBooleanPipe,
        DateCustomPipe,
        ImageUrlPipe,
        SingleSvgPipe,
        SortByPipe,
        TimeAgoPipe,
        ParseIsoPipe,
        PhoneNumberPipe,
        FeedContentPipe,
        PersonNamePipe,
        FatherNamePipe,
        MotherNamePipe,
        ScoreStatusPipe,
        AmountPipe,
    ],
})
export class PipesModule {}
